



// 扫码符号——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `icon/scanCode/index${i + 1}`,
  name: `icon/scanCodeIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/scanCode/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 扫码符号——主流程，开始
    ...MainRoutes,
  ],
};
